import Keycloak from 'keycloak-js';
import { clientEnv } from '../config/env';

let instance: Keycloak | null = null;
let initPromise: Promise<boolean> | null = null;

/** Single Keycloak client for the SPA — do not call `new Keycloak()` elsewhere. */
export function getKeycloak(): Keycloak {
  if (!instance) {
    const { url, realm, clientId } = clientEnv.keycloak;
    instance = new Keycloak({
      url,
      realm,
      clientId,
    });
  }
  return instance;
}

/**
 * Runs `keycloak.init` at most once per page load.
 * Safe under React StrictMode (double mount) — second mount awaits the same promise.
 */
export function ensureKeycloakInitialized(): Promise<boolean> {
  const keycloak = getKeycloak();
  if (!initPromise) {
    const { onLoad, silentCheckSsoRedirectUri } = clientEnv.keycloak;
    initPromise = keycloak.init({
      onLoad,
      pkceMethod: 'S256',
      checkLoginIframe: false,
      ...(onLoad === 'check-sso' && silentCheckSsoRedirectUri ? { silentCheckSsoRedirectUri } : {}),
    });
  }
  return initPromise;
}
